module.exports = __webpack_public_path__ + "static/media/trophy.9ee2d7ce.svg";